import React from 'react';

import WhatsIncluded from '@zego/components/molecules/WhatsIncluded';

import PurpleTick from '@zego/static/svgs/TickPurpleFilled.svg';

export default function BrokerWhatsIncluded(): JSX.Element {
  const data = [
    {
      itemIcon: PurpleTick,
      items: [
        { id: '0', text: 'Competitive commission' },
        {
          id: '1',
          text: 'Access to our fleet portal—manage multiple policies 24/7',
        },
        {
          id: '2',
          text: 'Add and remove vehicles instantly, with no admin fees',
        },
      ],
    },
    {
      itemIcon: PurpleTick,
      items: [
        { id: '3', text: 'Monitor progress of claims with ease' },
        { id: '4', text: 'Receive tailored risk insights and advisory' },
        { id: '5', text: 'Dedicated account manager and support team' },
      ],
    },
  ];

  return <WhatsIncluded data={data} />;
}
